
app.pagecontactController = app.pagecontactController || {};
app.pagecontactController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.eventForm();
    },

    eventForm : function () {
        /*
         * wpcf7invalid — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because there are fields with invalid input.
         * wpcf7spam — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because a possible spam activity has been detected.
         * wpcf7mailsent — Fires when an Ajax form submission has completed successfully, and mail has been sent.
         * wpcf7mailfailed — Fires when an Ajax form submission has completed successfully, but it has failed in sending mail.
         * wpcf7submit — Fires when an Ajax form submission has completed successfully, regardless of other incidents.
         */

        if (!Modernizr.inputtypes.date) {
            $('input[type="date"]').attr('placeholder', 'aaaa-mm-dd');
            $('input[type="date"]').datepicker({
                changeMonth: true,
                changeYear: true
            });
            $('input[type="date"]').datepicker( "option", "dateFormat", 'yy-mm-dd' );
        }

        var wpcf7Elm = document.querySelector( '.wpcf7' );

        $('form .btn-submit input').on('click', function () {
            $(this).closest('div').addClass('load');
            console.log('btn submit');
        });

        wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
            $('form .btn-submit').removeClass('load');
            console.log('wpcf7invalid');
        }, false );

        wpcf7Elm.addEventListener( 'wpcf7spam', function( event ) {
            $('form .btn-submit').removeClass('load');
            console.log('wpcf7invalid');
        }, false );

        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
            $('form .btn-submit').removeClass('load');
            console.log('wpcf7invalid');
        }, false );

        wpcf7Elm.addEventListener( 'wpcf7mailfailed', function( event ) {
            $('form .btn-submit').removeClass('load');
            console.log('wpcf7invalid');
        }, false );
    }
};

$(document).ready(function(){
    app.pagecontactController.defaultAction.init();
});
